<div class="text-center mt-5">
    <h1>Payment Failed</h1>
    <p>
      We're sorry but something went wrong while processing your payment. Please try again and if the issue persists please get in
      touch and we will look into the issue.
    </p>
    <a class="btn btn-primary" [routerLink]="['/']">Okay</a>
  </div>
